/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface FilterConf {
    field?: string;
    operator?: FilterConf.OperatorEnum;
    value?: string;
    values?: Array<string>;
    pattern?: string;
    /** Filtre sur champ NUMBER : valeur entière ou décimale (choix UI, ne sert pas à la comparaison). */
    decimal?: boolean;
    /** Filtre sur champ NUMBER : séparateur décimal de saisie ('EN' point, 'FR' virgule), mêmes valeurs
     * que TargetFieldDestination.localInput côté mapping. */
    localInput?: 'EN' | 'FR';
}

export namespace FilterConf {
    export type OperatorEnum =
        'IS_EMPTY'
        | 'EQUAL'
        | 'NOT_EQUAL'
        | 'INCLUDE'
        | 'LESS_THAN_OR_EQUAL'
        | 'GREATER_THAN_OR_EQUAL'
        | 'LESS_THAN_OR_EQUAL_DELTA'
        | 'GREATER_THAN_OR_EQUAL_DELTA'
        | 'EQUAL_DATE'
        | 'NUMBER_GREATER_THAN'
        | 'NUMBER_GREATER_THAN_OR_EQUAL'
        | 'NUMBER_LESS_THAN'
        | 'NUMBER_LESS_THAN_OR_EQUAL';
    export const OperatorEnum = {
        ISEMPTY: 'IS_EMPTY' as OperatorEnum,
        EQUAL: 'EQUAL' as OperatorEnum,
        NOT_EQUAL: 'NOT_EQUAL' as OperatorEnum,
        INCLUDE: 'INCLUDE' as OperatorEnum,
        LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL' as OperatorEnum,
        GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL' as OperatorEnum,
        LESS_THAN_OR_EQUAL_DELTA: 'LESS_THAN_OR_EQUAL_DELTA' as OperatorEnum,
        GREATER_THAN_OR_EQUAL_DELTA: 'GREATER_THAN_OR_EQUAL_DELTA' as OperatorEnum,
        EQUAL_DATE: 'EQUAL_DATE' as OperatorEnum,
        NUMBER_GREATER_THAN: 'NUMBER_GREATER_THAN' as OperatorEnum,
        NUMBER_GREATER_THAN_OR_EQUAL: 'NUMBER_GREATER_THAN_OR_EQUAL' as OperatorEnum,
        NUMBER_LESS_THAN: 'NUMBER_LESS_THAN' as OperatorEnum,
        NUMBER_LESS_THAN_OR_EQUAL: 'NUMBER_LESS_THAN_OR_EQUAL' as OperatorEnum,
    };
}
